import {
    renderScript,
    renderLink
} from '@/utils'



// 网易滑动验证方式
export const wySafeCheckout = () => {
    return new Promise((resolve) => {
        if (window.initNECaptcha) {
            resolve()
            return
        }
        renderScript(`https://cstaticdun.126.net/load.min.js?t=${Number(new Date())}`).then(
            resolve
        )
    })
}


const RongIMLib = () => {
    return new Promise((resolve) => {
        // 直播间页添加融云SDK
        if (window.RongIMLib) {
            resolve()
            return
        }
        renderScript(
            'https://fr-static.shopshops.top/static/js/rongyun/2.5.6/RongIMLib-2.5.6.min.js'
        ).then(resolve)
    })
}

// 这里没使用，被翊豪放到index.html里了
const AgoraInfo = () => {
    return new Promise(async (resolve) => {
        // 直播间页添加融云SDK
        if (window.AgoraRTC && window.AgoraRTS) {
            resolve()
            return
        }
        Promise.all([
            renderScript('https://fr-static.shopshops.top/20220701/AgoraRTCSDK3611.0b80cd05942c1790.js'),
            renderScript('https://fr-static.shopshops.top/static/js/agora/3.1.1/AgoraRTS.js')
        ]).then(resolve)
    })
}

export const Aliplayer = () => {
    return new Promise(async (resolve) => {
        // 直播间页添加Aliplayer SDK
        if (window.Aliplayer) {
            resolve()
            return
        }
        renderLink(
            'https://fr-static.shopshops.top/static/css/aliplayer/2.8.2/aliplayer-min.css'
        )
        renderScript(
            'https://fr-static.shopshops.top/static/js/aliplayer/2.8.2/aliplayer-h5-min.js'
        ).then(resolve)
    })
}
